import React, {useRef} from 'react';
import IconPanelContainer from "../Containers/IconPanelContainer";
import PanelInformationItem from "../../Atoms/Items/PanelInformationItem";
import CompanyInformationSection from "../Sections/CompanyInformationSection";
import BasicCompanyInformationModal from "../Modals/BasicCompanyInformationModal";

const BasicCompanyInformationPanel = () => {
  const modal = useRef()

  const handleOpenModal = () => {
    modal.current.openModal()
  }

  return (
    <div>
      <IconPanelContainer
        icon="building"
        title="Información básica"
        editFunction={handleOpenModal}
        container={{
          className: 'ed-grid rows-gap s-gap-3'
        }}
      >

        <CompanyInformationSection
          title="Preferencias de pago"
        >
          <PanelInformationItem
            title="Frecuencia de pago"
            text="Quincenal, mensual"
          />
          <PanelInformationItem
            title="Período inicial"
            text="1 de agosto 2015"
          />
        </CompanyInformationSection>

        <CompanyInformationSection
          title="Pila"
        >
          <PanelInformationItem
            title="ARL"
            text="Seguros Suramericana S.A."
          />
          <PanelInformationItem
            title="Fecha de constitución"
            text="15 de abril del 2015"
          />
        </CompanyInformationSection>

        <CompanyInformationSection
          title="Leyes aplicable"
        >
          <PanelInformationItem
            title="Aplica ley 1429"
            text="Sí"
          />
          <PanelInformationItem
            title="Aplica ley 1607"
            text="Sí"
          />
          <PanelInformationItem
            title="Aplica ley 590"
            text="Sí"
          />
        </CompanyInformationSection>
      </IconPanelContainer>
      <BasicCompanyInformationModal ref={modal} />
    </div>
  );
};

BasicCompanyInformationPanel.propTypes = {};

export default BasicCompanyInformationPanel;
